import React, {useContext} from "react";
import {Modal, ScrollView, View} from "react-native";
import MainStyle from "../../MainStyle";
import Div from "../lib/Div";
import P from "../lib/P";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import Btn from "../components/Btn";
import {StoreContext} from "../components/StoreContextProvider";
import {formatCurrency} from "../utils";

type Props = { visible: boolean, onRequestClose: () => void };

const LevelUpModal = (props: Props) => {
  const {visible} = props;
  const Context = useContext(StoreContext);
  const {extendedUserData} = Context;

  return (
    <Modal animationType="fade" transparent visible={visible} statusBarTranslucent={false} hardwareAccelerated={false}
           onRequestClose={props.onRequestClose}>
      <View style={[MainStyle.fix_gradient_and_modal_error_in_landscape, MainStyle.flex1, MainStyle.bg_filter_modal]}>
        <ScrollView contentContainerStyle={MainStyle.flex1}>
          <Div minH="100%" alignItems="center" justifyContent="center">
            <Div bg="#131314" w={343} rounded={16} overflow="hidden">
              <Div position="relative" bg="#252526" justifyContent="center">
                <P fontFamily="DavisSans-Medium" ta="center" lh={48}>Level Up!</P>
                <FontAwesome5
                  name="times" size={28} color="white" style={[MainStyle.absolute, MainStyle.r_10]}
                  onPress={props.onRequestClose}
                />
              </Div>

              <Div px={20} pb={30} pt={40} alignItems="center">
                <Div px={20} py={6} h={30} alignItems="center" justifyContent="center" rounded={32} bg="#0B3507"
                     borderWidth={1} borderColor="#2DFF1A" mb={20}>
                  <P fontFamily="DavisSans-Regular" fs={20}>Max {formatCurrency(extendedUserData.maxShotAmount / 100)} per shot!</P>
                </Div>

                <P fontFamily="DavisSans-Regular" mb={40}>New shot amount unlocked!</P>

                <Btn bg="#3369FF" onPress={props.onRequestClose} w="100%">
                  <P fontFamily="DavisSans-Medium" lh={56} ta="center">Got it!</P>
                </Btn>
              </Div>
            </Div>
          </Div>
        </ScrollView>
      </View>
    </Modal>
  );
};

export default LevelUpModal;
